import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import { LangToggle } from "@/components/Toggles";

export const AdminHeader = ({ children }) => {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center gap-4">
        <Link to="/admin" className="font-press text-lg text-primary" data-testid="admin-logo-link">SamQuest</Link>
        <div className="flex-1 min-w-0">{children}</div>
        <LangToggle />
        <span className="hidden md:block text-sm text-muted-foreground">{user?.email}</span>
        <Button variant="ghost" size="sm" data-testid="admin-logout-button" onClick={async () => { await logout(); nav("/admin/login"); }}>
          <LogOut className="w-4 h-4 mr-1.5" />{t("logout")}
        </Button>
      </div>
    </header>
  );
};

export const CustomerAvatar = ({ src, className = "w-11 h-11" }) => (
  <div className={`rounded-full overflow-hidden border-2 border-card bg-slate-700 shrink-0 ${className}`}>
    <img src={src} alt="" className="pixelated w-full h-full object-cover scale-[1.8] origin-[50%_22%]" />
  </div>
);
